import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import {
  packageLabelToClassName,
  formatMonthlyCostInLocaleCurrency,
  getCoreCostFromSkus,
  calculateSavingsPercent,
} from '~pricing/lib/helpers';
import { PricingExperienceContext } from '~pricing/lib/PricingExperience/PricingExperienceContext';
import { TEAM_COMPARISON_PACKAGES } from '~pricing/lib/constants';
import { RibbonTextOverridePropType } from '~pricing/lib/proptypes';

import PackageHeader from './PackageHeader';

const TeamPackageHeader = ({ packageName, skuCosts, details, ribbonText: ribbonTextOverride = null }) => {
  const packageClassName = packageLabelToClassName(details);
  const coreSeatCost = getCoreCostFromSkus(skuCosts);
  const formattedPrice = formatMonthlyCostInLocaleCurrency(coreSeatCost);
  const packageData = useContext(PricingExperienceContext);

  if (!packageData) {
    return null;
  }

  // If no overidden ribbon text was path, check for a comparison package to check against
  let ribbonText = ribbonTextOverride;
  if (!ribbonText && ribbonText !== false) {
    const comparisonPackageName = TEAM_COMPARISON_PACKAGES[packageName];
    if (comparisonPackageName) {
      const comparisonPackage = packageData.find(packageObj => packageObj.package === comparisonPackageName);
      const comparisonSeatCost = getCoreCostFromSkus(comparisonPackage.skuCost);
      const savingsPercentage = calculateSavingsPercent(comparisonSeatCost, coreSeatCost);
      ribbonText = savingsPercentage > 0 ? `SAVE ${savingsPercentage}% *` : null;
    }
  }

  return (
    <PackageHeader
      packageClassName={packageClassName}
      packageName={packageName}
      packageLabel={details.displayName.toUpperCase()}
      priceValue={formattedPrice}
      priceUnit=" / user / month"
      byline="Starting at 3 users, billed annually"
      ribbonText={ribbonText}
    />
  );
};

TeamPackageHeader.propTypes = {
  packageName: PropTypes.string.isRequired,
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  skuCosts: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  ribbonText: RibbonTextOverridePropType,
};

TeamPackageHeader.defaultProps = {
  ribbonText: null,
};

export default TeamPackageHeader;
